/*
  const mySinePath = new SinewaveTextPath({
    fill: 'black',
    fontSize: 24,
    fontFamily: 'Arial',
    text: 'Initial Text Initial Text Initial Text Initial',
    amplitude: 80,
    frequency: 200,
    waves: 2
  });

  selectNode(mySinePath);
  //console.log("mySinePath", mySinePath);
  layer.add(mySinePath);
  layer.draw(); 
*/


class SinewaveTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'SinewaveTextPath';  
    
    this.app = config.app;

    this.amplitude(config?.amplitude ?? 80);
    this.frequency(config?.frequency ?? 120);
    this.waves(config?.waves ?? 2);
  } 


  static getAttrNames() { return ['amplitude', 'frequency', 'waves']; }
  static getDefaultAttrs() { return { amplitude: 80, frequency: 120, waves: 2 }; }


  amplitude(v) {
    if (v === undefined) return this.attrs.amplitude ?? 0;
    this.attrs.amplitude = v;
    this.updatePath();
    return this;
  }


  frequency(v) {
    if (v === undefined) return this.attrs.frequency ?? 0;
    this.attrs.frequency = v;
    this.updatePath();
    return this;
  }


  waves(v) {
    if (v === undefined) return this.attrs.waves ?? 0;
    this.attrs.waves = v;
    this.updatePath();
    return this;
  }


  updatePath() {
    this.setData(this.generateSvgPath(this.amplitude(), this.frequency(), this.waves()));
  }


  generateSvgPath(amplitude, frequency, waves) {
    // Move To (uppercase = absolute coordinates) ...
    const mv = ([x, y]) => `M ${x} ${y}`;

    // Cubic Bézier (relative coordinates)
    const to = (y, f) => ` c ${f / 2} 0 ${f / 2} ${y} ${f} ${y}`;
    const dn = (y = 10, f = 10) => to(y, f);
    const up = (y = 10, f = 10) => to(-y, f);
    let start = [0, amplitude * 1.5],
        size = [600, amplitude * 2];
    
    let str = mv(start) + (up(amplitude, frequency) + dn(amplitude, frequency)).repeat(waves);

    return str;
  }
}
